import React, { Component } from "react";

import "./quickbooks-moved-accounts.css";
import UtilityService from "../../../../services/UtilityService";

class QuickBooksMovedAccounts extends Component {
	renderMovedAccount = moved => {
		const periodLabel = moved.period === "current" ? "This year" : "Last year";
		return (
			<div key={`${moved.period}-${moved.qboAccountId}`} className="tk-ledger__row qbmoved__row">
				<span className="qbmoved__account">
					{moved.accountName}
					<span className="qbmoved__period">{periodLabel}</span>
				</span>
				<span className="tk-ledger__amount">{UtilityService.formatCurrency(moved.pulled)}</span>
				<span className="tk-ledger__amount">{UtilityService.formatCurrency(moved.now)}</span>
				<span className="tk-ledger__amount qbmoved__amount--difference">{UtilityService.formatCurrency(moved.difference)}</span>
			</div>
		);
	};

	render() {
		const { moved } = this.props;
		if (!moved || moved.length === 0) return null;
		return (
			<div data-test="qbo-moved-accounts">
				<div className="tk-ledger__row tk-ledger__row--head qbmoved__row">
					<span>QuickBooks account</span>
					<span className="tk-ledger__amount">Pulled</span>
					<span className="tk-ledger__amount">Now</span>
					<span className="tk-ledger__amount">Difference</span>
				</div>
				{moved.map(this.renderMovedAccount)}
			</div>
		);
	}
}

export default QuickBooksMovedAccounts;
